type CollapsedCaretScrollBehaviorArgs = {
  alwaysShow: boolean;
  hasActiveSuggestion: boolean;
  hasActiveComment: boolean;
  hasTableSelection: boolean;
  isCollapsedRangeSelection: boolean;
};

/**
 * In always-show mode, measuring an offscreen caret during scroll can cause the browser
 * to keep that caret visible. For caret-only selection state, prefer hiding the toolbar
 * over re-measuring the selection on every scroll.
 */
export function shouldHideToolbarForCollapsedCaretScroll({
  alwaysShow,
  hasActiveSuggestion,
  hasActiveComment,
  hasTableSelection,
  isCollapsedRangeSelection,
}: CollapsedCaretScrollBehaviorArgs): boolean {
  return (
    alwaysShow &&
    !hasActiveSuggestion &&
    !hasActiveComment &&
    !hasTableSelection &&
    isCollapsedRangeSelection
  );
}
